import PickImage from "./PickImage";
export default PickImage;